import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.reset_role_filter = function () {
  const form = document.getElementById(this.getAttribute("target"))
  if (!form) return

  form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.checked = false
  })

  form.querySelector("[data-role-filter-target='details']").open = false

  const count = form.querySelector("[data-role-filter-target='count']")
  count.textContent = ""
  count.classList.add("hidden")
  count.classList.remove("inline-flex")

  form.querySelector("[data-role-filter-target='clear']").classList.add("hidden")
  window.history.replaceState({}, "", this.getAttribute("url"))
}

export default class extends Controller {
  static targets = [ "count", "clear", "details" ]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  submit() {
    const url = new URL(this.element.action, window.location.origin)
    url.search = new URLSearchParams(new FormData(this.element))

    fetch(url, { headers: { Accept: "text/vnd.turbo-stream.html" } })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))

    window.history.replaceState({}, "", url)
    this.updateControls()
  }

  clear(event) {
    event.preventDefault()
    this.element.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = false
    })
    this.submit()
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.detailsTarget.open = false
  }

  updateControls() {
    const count = this.element.querySelectorAll('input[type="checkbox"]:checked').length
    this.countTarget.textContent = count
    this.countTarget.classList.toggle("hidden", count === 0)
    this.countTarget.classList.toggle("inline-flex", count > 0)
    this.clearTarget.classList.toggle("hidden", count === 0)
  }
}
